import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Slider from "react-slick";
import Srcset from "@/components/common/Srcset";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import CTA from "@/components/common/CTA";
import ProductItemTile from "../../ProductListingComp/ProductItemTile";
import FeatureCarousel from "./FeatureCarousel";
import StoryCard from "../SuperBrands/StoryCard";
import styles from "../SuperBrands/superBrands.module.scss";
import { isSuperbrandHeroPresent } from "@/redux/actions/headerAction";
import { selectSliderElements } from "@/helpers/generalHelper";
import { useIntersection } from "../../common/UseIntersection";
import { reportError } from "@/helpers/errorHelper";

function NextArrow(props) {
  const { className, onClick, refCallBack } = props;

  return (
    <div className={className} onClick={onClick} tabIndex={0} ref={refCallBack}>
      <Srcset
        requirePath={true}
        svgFile={true}
        src={"images/Icons/Chevron/large.svg"}
        alt="Arrow Button"
        height="12"
        width="12"
      />
    </div>
  );
}

function PrevArrow(props) {
  const { className, onClick, refCallBack } = props;
  return (
    <div className={className} onClick={onClick} tabIndex={0} ref={refCallBack}>
      <Srcset
        requirePath={true}
        svgFile={true}
        src={"images/Icons/Chevron/large.svg"}
        alt="Arrow Button"
        height="12"
        width="12"
      />
    </div>
  );
}

export default function Carousel(props) {
  const isTablet = useMediaQuery("(min-width: 601px) and (max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [active, setActive] = useState(null);
  const [slideClass, setSlideClass] = useState("");
  const PLPWishlistClicked = useSelector((state) => state.general.plp_wishlist_clicked);
  const handleClick = (e, index) => {  
    if (!e) {
      setSlideClass(styles.slide_right);
      setTimeout(() => {
        setSlideClass("");
        setActive(index);
      }, 1000);
    } else {
      setTimeout(() => {
        setActive(index);
        setSlideClass(styles.slide_left);
      }, 1000);    
    }
  };

  let stateInitial = {
    activeSlide: 1,
  };
  const [state, setState] = useState(stateInitial);
  const isSuperbrandHeroPresent = useSelector(
    (state) => state.header.isSuperbrandHeroPresent
  );

  const nextArrowRef = useRef(null);
  const prevArrowRef = useRef(null);

  const handleArrowFocus = () => {
    const navbarHeight = 60;
    const focusedElement = document.activeElement;

    if(focusedElement === nextArrowRef?.current ){
      if(!inViewportNext || (nextArrowRef.current.getBoundingClientRect().top < navbarHeight)){
        focusedElement.scrollIntoView({behavior: "smooth", block: "center"});
      }
    }
    if (focusedElement === prevArrowRef?.current){
      if(!inViewportPrev || (prevArrowRef.current.getBoundingClientRect().top < navbarHeight)){
        focusedElement.scrollIntoView({behavior: "smooth", block: "center"});
      }
    }
  }

  let settings_3 = {
    accessibility:true,
    dots: false,  
    infinite:
      props.productsList != "undefined" &&
      props.productsList &&
      props.productsList.length > (props.isProductCarousel? props.desktopSlidesToScroll : 2),
    speed: 500,
    slidesToShow: props.desktopSlidesToShow,
    slidesToScroll: props.desktopSlidesToScroll,
    arrows: true,
    autoplay: false,
    lazyLoad: true,
    draggable: false,
    className: (props.productsList != "undefined" &&
    props.productsList &&
    props.productsList.length > props.desktopSlidesToScroll) ? 'infinite' : 'non-infinite',
    beforeChange: (oldIndex, newIndex) => {
      const newActiveSlide = Math.ceil((newIndex + 1) / props.desktopSlidesToScroll);
      setState((prevState) => ({
        ...prevState,
        activeSlide: newActiveSlide,
      }));
    },
    afterChange: (activeSlide) =>
      setState({
        activeSlide: Math.ceil(activeSlide / props.desktopSlidesToScroll) + 1,
      }),
    nextArrow: <NextArrow refCallBack={nextArrowRef}/>,
    prevArrow: <PrevArrow refCallBack={prevArrowRef}/>,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          dots: false,
          slidesToShow: props.tabletSlidesToShow,
          slidesToScroll: props.tabletSlidesToScroll,
          arrows: false,
          autoplay: false,
          infinite: props.isProductCarousel? (props.productsList != "undefined" &&
          props.productsList &&
          props.productsList.length > props.tabletSlidesToScroll) : true,
          className: (props.productsList != "undefined" &&
          props.productsList && props.productsList.length > props.tabletSlidesToScroll) ? 'infinite' : 'non-infinite',
          draggable: true,
          touchMove:PLPWishlistClicked?false: true,
          beforeChange: (oldIndex, newIndex) => {
            const newActiveSlide = Math.ceil((newIndex + 1) / props.tabletSlidesToScroll);
            setState((prevState) => ({
              ...prevState,
              activeSlide: newActiveSlide,
            }));
          },
          afterChange: (activeSlide) =>
            setState({
              activeSlide: Math.ceil(activeSlide / props.tabletSlidesToScroll) + 1,
            }),
        },
      },
      {
        breakpoint: 767,
        settings: {
          infinite: props.isProductCarousel? (props.productsList != "undefined" &&
          props.productsList &&
          props.productsList.length > props.mobileSlidesToScroll) : true,
          slidesToShow: props.mobileSlidesToShow,
          slidesToScroll: props.mobileSlidesToScroll,
          className: (props.productsList != "undefined" &&
          props.productsList && props.productsList.length > props.mobileSlidesToScroll) ? 'infinite' : 'non-infinite',
          initialSlide: props.isProductCarousel? 1 : 2,
          centerMode: props.isProductCarousel? false : true,
          arrows: false,
          autoplay: false,
          draggable: true,
          beforeChange: (oldIndex, newIndex) => {
            const newActiveSlide = Math.ceil((newIndex + 1) / props.mobileSlidesToScroll);
            setState((prevState) => ({
              ...prevState,
              activeSlide: newActiveSlide,
            }));
          },
          afterChange: (activeSlide) =>
            setState({ activeSlide: Math.ceil(props.isProductCarousel? (activeSlide / props.mobileSlidesToScroll) : activeSlide) + 1 }),
        },
      },
    ],
  };

  const sliderRef= useRef(null); 
  const feature_sliderRef=useRef(null);
  const inViewportNext = useIntersection(nextArrowRef, "0px");
  const inViewportPrev = useIntersection(prevArrowRef, "0px");
  const [tabPressed, setTabPressed] = useState(false);
  const isMobileDevice = useMediaQuery("(max-width: 767px)");
  useEffect(()=>{
    if (isMobileDevice) return; 
    const handleKeyDown = (event) =>{
      try {
        if(event?.key === "Tab" && !tabPressed){
          setTabPressed(true);
          selectSliderElements(sliderRef,feature_sliderRef); 
        } 
      } catch (error) {
        reportError("tab indexing error common carousel & not tab pressed");
        reportError(error) // Log error using reportError function
      }
    };
    handleArrowFocus();
    const handleKeyUp = (event) =>{
      try {
        if(event?.key === "Tab" ){
          setTabPressed(false);
        }
      } catch (error) {
        reportError("tab indexing error common carousel");
        reportError(error) // Log error using reportError function
      }

    };

    window.addEventListener("keydown",handleKeyDown);
    window.addEventListener("keyup",handleKeyUp);

    return ()=>{
      window.removeEventListener("keydown",handleKeyDown);
      window.removeEventListener("keyup",handleKeyUp);
    }
  },[sliderRef,feature_sliderRef,tabPressed, isMobileDevice]);

  /* START: Inner Feature Carousel field changes */
  const backgroundColorClass = props.isInnerCarousel
    ? props._backgroundColor && "bg-" + props._backgroundColor.toLowerCase()
    : props.backgroundColor && "bg-" + props.backgroundColor.toLowerCase();
  const carouselHeader = props.isInnerCarousel
    ? props._carouselHeader
    : props.carouselHeader;
  const carouselBody = props.isInnerCarousel
    ? props._carouselBody
    : props.carouselBody;
  const ctaText = props.isInnerCarousel ? props._ctaText : props.ctaText;
  const ctaUrl = props.isInnerCarousel ? props._ctaUrl : props.ctaUrl;
  const cardList = props.isInnerCarousel ? props._cardList : props.cardList;

  /* END: Inner Feature Carousel field changes */

  const productsList =
    typeof props.productsList != "undefined" ? props.productsList : [];

  let products = null;
  let superBrandsInnerTemplate = null;
  let slideCount = 1;

  if (Array.isArray(productsList)) {
    slideCount = Math.ceil(productsList.length / props.desktopSlidesToScroll);
    if (isMobile) {
      slideCount = props.isProductCarousel? (Math.ceil(productsList.length / props.mobileSlidesToScroll)) : Math.ceil(productsList.length);
    } else if (isTablet) {
      slideCount = Math.ceil(productsList.length / props.tabletSlidesToScroll);
    }
    products = productsList.map((product, index) => {
      var image = product.image;
      var _image = product._image;
      if (isMobile) {
        image = product.imageMobile ? product.imageMobile : product.image;
        _image = product._imageMobile ? product._imageMobile : product._image;
      } else if (isTablet) {
        image = product.imageTablet ? product.imageTablet : product.image;
        _image = product._imageTablet ? product._imageTablet : product._image;
      } else {
        image = product.image;
        _image = product._image;
      }
      if (
        (props.isInnerCarousel &&
          product._productOrImage &&
          product._productOrImage == "image" &&
          _image) ||
        (product.productOrImage &&
          product.productOrImage == "image" &&
        image)
      ) {
        const imageWrapper = (
          <div className="product_wrapper">
            <div className="image_card_wrapper">
              <div className="image_card">
                <Srcset
                  height="100%"
                  width="100%"
                  src={props.isInnerCarousel ? _image : image}
                  alt = {product._imageAlt ? product._imageAlt : (product.imageAlt ? product.imageAlt : (props.isInnerCarousel ? product._header : product.header))}
                  className="carouselSingleImage"
                />
              </div>

              <div className="image_header x-large-md small-sm small-xs italic">
                {props.isInnerCarousel ? product._header : product.header}
              </div>
              <div className="image_body small-md x-small-sm x-small-xs">
                {props.isInnerCarousel ? product._body : product.body}
              </div>
            </div>
          </div>
        );

        return (
          <div key={index}>
            <div
              className={`slide_wrapper ${isSuperbrandHeroPresent? "interaction super_brands_card":""}`}
              onClick={() => product.superBrands && handleClick(true, index)}
            >
              {product.superBrands ? (
                imageWrapper
              ) : (props.isInnerCarousel && product._url) || product.url ? (
                <a href={props.isInnerCarousel ? product._url : product.url} tabIndex={0}>
                  {imageWrapper} 
                </a>
              ) : (
                imageWrapper
              )}
            </div>
          </div>
        );
      } else if (
        (props.isInnerCarousel &&
          typeof product._product != "undefined" &&
          typeof product._product.data != "undefined") ||
        (typeof product.product != "undefined" &&
          typeof product.product.data != "undefined")
      ) {
        let productDetails = props.isInnerCarousel
          ? product._product.data
          : product.product.data;
        const firstVariant = productDetails.variants[0];

        //formatting product data to match algolia
        productDetails.image = productDetails.product_image =
          productDetails?.images[0]?.src;
        productDetails.price = firstVariant.priceV2.amount;
        productDetails.compare_at_price =
          firstVariant.compareAtPriceV2 &&
          firstVariant.compareAtPriceV2.amount > 0
            ? firstVariant.compareAtPriceV2.amount
            : firstVariant.priceV2.amount;
        return (
          <div key={index}>
            <div className={`slide_wrapper`}>
              <div className="product_wrapper">
                <ProductItemTile
                  productDetails={productDetails}
                  isCarousel={true}
                  wishlistFeatureEnabled={props.wishlist}
                  impactMessageEnabled={false}
                  shouldAddRandomId={true}
                  key={index}
                />
              </div>
            </div>
          </div>
        );
      }
    });

    if (!props.isInnerCarousel) {
      superBrandsInnerTemplate = productsList.map((card, index) => {
        if (
          card.productOrImage &&
          card.productOrImage == "image" &&
          card.superBrands
        ) {
          if (
            card.storyTellingOrFeatureCarousel &&
            card.storyTellingOrFeatureCarousel == "Feature Carousel"
          ) {
            return (
              <div
                key={index}
                className={`${styles.story_card_wrapper}  ${
                  active === index && slideClass
                }`}
              >
                <FeatureCarousel
                  {...card}
                  handleClick={handleClick}
                  index={index}
                  isInnerCarousel={true}
                />
              </div>
            );
          } else {
            return (
              <div
                key={index}
                className={`${styles.story_card_wrapper}  ${
                  active === index && slideClass
                }`}
              >
                <StoryCard {...card} handleClick={handleClick} index={index} />
              </div>
            );
          }
        }
      });
    }
  }

  return (
    <div className={`main_product_slider ${backgroundColorClass}`}   id={props.id? props.id : ""}>
      {superBrandsInnerTemplate}
      <div className={`${props.carouselClass} ${props.carouselTitle ? '' : 'no_title'}`}>
      <div className="slider-title">
        {props.carouselTitle && (
            <>
              <h3 className="slider-title-heading heading-350">
                {props.carouselTitle}
              </h3>
              {props.ctaText && (<CTA
                  text={props.ctaText}
                  link={props.ctaUrl? props.ctaUrl:""}
                  sizeClass="x-small-xs x-small-sm normal-md ml-30"
                  isHover={true}
                />)} 
            </>       
          )}
        </div>
        {(!props.isInnerCarousel || !isMobile) && slideCount > 1 &&(
          <div className={`small-md small-sm small-xs italic slider-counter ${isSuperbrandHeroPresent?"sb_icon":""}`}>
            <span className="active-slide">{state.activeSlide}</span>
            <span className="slash">/</span>
            <span className="total-slide">{slideCount}</span>
          </div>
        )}
        {props.isFeature && (
          <div className={`feature-carousel-text-block ${isSuperbrandHeroPresent?"superbrands_carousel":""}`}>
            {props.isInnerCarousel && (
              <div
                className="back_arrow"
                onClick={() => props.handleClick(false, props.index)}
              >
                <Srcset
                  requirePath={true}
                  svgFile={true}
                  src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
                  alt="back button"
                  height="16"
                  width="19.11"
                />
              </div>
            )}
            {props.isInnerCarousel && (
              <div
                className="mobile_close"
                onClick={() => props.handleClick(false, props.index)}
              >
                <Srcset
                  requirePath={true}
                  svgFile={true}
                  src={"images/Icons/Cross/Large.svg"}
                  alt="cross-button"
                  height="14"
                  width="14"
                />
              </div>
            )}
            <h3 className={`feature-carousel-header heading-350 ${isSuperbrandHeroPresent?"sb_header":""}`}>
              {carouselHeader}
            </h3>
            <div className={`large-md small-sm ${isSuperbrandHeroPresent?"superbrands-carousel-body x-small-xs":"feature-carousel-body"}`}>
              {carouselBody}
            </div>
            <div className={`cta_wrapper ${isSuperbrandHeroPresent?"super_brands":""}`}>
              { ctaText && <CTA
                text={ctaText}
                link={ctaUrl}
                sizeClass="bordered x-small-xs x-small-sm normal-md"
              />}
            </div>
          </div>
        )}
        {typeof products != "undefined" &&
        typeof products != "string" &&
        products &&
        products.length > 0 ? (
          props.isFeature ? (
            <div className={`slider-wrapper ${props.zoomEffect ? 'zoom_img' : ''}`}>
              <Slider ref={feature_sliderRef} {...settings_3} aria-live="polite" role="region">{products}</Slider>
            </div>
          ) : (
            <Slider ref={sliderRef} {...settings_3}  aria-live="polite" role="region">{products}</Slider>
          )
        ) : (
          "Enter products here"
        )}
      </div>
    </div> 
  );
}
